import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

/** Exposed so callers can build a raw request (e.g. a keepalive fetch on unload). */
export const supabaseUrl = url;
export const supabaseAnonKey = anon;

export function isSupabaseConfigured() {
  return Boolean(url && anon);
}

export const supabase = isSupabaseConfigured() ? createClient(url, anon) : null;
